import {
  Heading,
  ListItem,
  OrderedList,
  Text,
  UnorderedList,
  VisuallyHidden,
  chakra,
} from '@chakra-ui/react';
import { id } from 'date-fns/locale';
import type { MDXComponents } from 'mdx/types';
import Trans from 'next-translate/Trans';
import Image, { ImageProps } from 'next/image';

// This file allows you to provide custom React components
// to be used in MDX files. You can import and use any
// React component you want, including inline styles,
// components from other libraries, and more.

export function useMDXComponents(components: MDXComponents): MDXComponents {
  return {
    // Allows customizing built-in components, e.g. to add styling.
    h1: ({ children }) => (
      <Heading
        data-group
        as="h2"
        size="md"
        mt={['xl', null, '2xl', '3xl']}
        mr="lg"
        sx={{ '&:first-of-type': { mt: 0 } }}
        _hover={{ a: { display: 'inline-block' } }}
      >
        <span>{children}</span>
        <chakra.a aria-label="anchor" href={`#${id}`} color="muted" pl="xs" display="none">
          <Trans i18nKey="articles:article.copy" components={{ 0: <VisuallyHidden /> }} />
        </chakra.a>
      </Heading>
    ),
    h2: ({ children }) => (
      <Heading as="h2" size="md">
        {children}
      </Heading>
    ),
    h3: ({ children }) => (
      <Heading as="h2" size="md">
        {children}
      </Heading>
    ),
    h4: ({ children }) => (
      <Heading as="h2" size="md">
        {children}
      </Heading>
    ),
    img: props => (
      <Image sizes="100vw" style={{ width: '100%', height: 'auto' }} {...(props as ImageProps)} />
    ),
    b: ({ children }) => (
      <Text as="strong" fontWeight="bold">
        {children}
      </Text>
    ),
    strong: ({ children }) => (
      <Text as="strong" fontWeight="bold">
        {children}
      </Text>
    ),
    ol: ({ children }) => <OrderedList>{children}</OrderedList>,
    ul: ({ children }) => <UnorderedList>{children}</UnorderedList>,
    li: ({ children }) => <ListItem color="white">{children}</ListItem>,
    p: ({ children }) => <Text whiteSpace="pre-wrap">{children}</Text>,
    ...components,
  };
}
